import { apiUtils } from "../../../utils/apiUtils";
import type {
  DashboardStatisticResponse,
  OwnCreatedDataResponse,
  DashboardStatisticRequest,
  UserActivityDataResponse,
  UserGrowthDataResponse,
} from "../types/dashboard-data.types";

export type {
  DashboardStatisticRequest,
  DashboardStatisticResponse,
  UserGrowthMonthlyData,
  UserGrowthPeriodInfo,
  OwnCreatedDataResponse,
  UserActivityDataResponse,
  UserGrowthDataResponse,
  UserGrowthWeeklyData,
} from "../types/dashboard-data.types";

export interface DashboardRequestOptions {
  signal?: AbortSignal;
}

export async function getStatistic(
  request: DashboardStatisticRequest,
  options?: DashboardRequestOptions,
): Promise<DashboardStatisticResponse> {
  return apiUtils.getData<DashboardStatisticResponse>(
    "/v1/portal/dashboard/statistic",
    "Failed to fetch statistics",
    { params: request, signal: options?.signal },
  );
}

export async function getUserGrowth(
  options?: DashboardRequestOptions,
): Promise<UserGrowthDataResponse> {
  return apiUtils.getData<UserGrowthDataResponse>(
    "/v1/portal/dashboard/user-growth",
    "Failed to fetch user growth",
    { signal: options?.signal },
  );
}

export async function getUserActivity(
  options?: DashboardRequestOptions,
): Promise<UserActivityDataResponse> {
  return apiUtils.getData<UserActivityDataResponse>(
    "/v1/portal/dashboard/user-activity",
    "Failed to fetch user activity",
    { signal: options?.signal },
  );
}

export async function getOwnCreated(options?: DashboardRequestOptions): Promise<OwnCreatedDataResponse> {
  return apiUtils.getData<OwnCreatedDataResponse>(
    "/v1/portal/dashboard/own-created",
    "Failed to fetch own created",
    { signal: options?.signal },
  );
}
